import { useTogglePopoverModal, useUpdatingProxyNiceModal } from '@lessonup/client-integration';
import { PlayerBarBottomButton, Student, useStudentsRemainingAndAnswered } from '@lessonup/players-modern';
import { IconCheckFill, IconSlideTypeQuizQuestion, styled } from '@lessonup/ui-components';
import React, { useRef } from 'react';
import { usePlayerTranslation } from '../../../../hooks/usePlayerTranslation';
import { RemainingStudentPopover } from './RemainingStudentPopover';

export const WaitingForStudents: React.FC = () => {
  const { remaining } = useStudentsRemainingAndAnswered();
  return <WaitingForStudentsPresentational remaining={remaining} />;
};

interface WaitingForStudentsProps {
  remaining: Student[];
}
export const WaitingForStudentsPresentational: React.FC<WaitingForStudentsProps> = ({ remaining }) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { t } = usePlayerTranslation();

  const modal = useUpdatingProxyNiceModal(
    RemainingStudentPopover,
    {
      parentSelector: () => buttonRef.current,
      direction: 'top',
      modalAnchor: 'center',
      students: remaining,
    },
    [remaining]
  );
  const [handleClick, handleMouseDown, isModalVisible] = useTogglePopoverModal(modal);

  return (
    <PlayerBarBottomButton
      ref={buttonRef}
      iconStart={remaining.length ? <IconSlideTypeQuizQuestion /> : <IconCheckFill />}
      active={isModalVisible}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      label={remaining.length ? t('labels.studentsRemaining') : t('labels.allStudentsAnswered')}
      buttonType={remaining.length ? 'neutral' : 'positive'}
      tipped
    >
      <TextWrapper>{remaining.length}</TextWrapper>
    </PlayerBarBottomButton>
  );
};

const TextWrapper = styled.div`
  width: 2ch;
`;
